import { axiosInstance } from "@/lib/axios-instance";
import { IInboundEmail, InboundEmailStatus } from "@/types/data-models";

interface InboxListResponse {
  status: string;
  emails: IInboundEmail[];
  counts: {
    needs_review: number;
    linked: number;
    ignored: number;
  };
}

export interface InboxDetailResponse {
  status: string;
  email: IInboundEmail;
  thread: IInboundEmail[];
}

interface InboxUpdateResponse {
  status: string;
  email: IInboundEmail;
}

interface ConvertEmailToDealResponse {
  status: string;
  deal_id: string;
  company_id: string;
  email: IInboundEmail;
}

export const inboxApi = {
  listEmails: async (
    workspaceId: string,
    status?: InboundEmailStatus,
    search?: string
  ) => {
    const response = await axiosInstance.get<InboxListResponse>(
      "/inbox-emails",
      {
        params: {
          workspace_id: workspaceId,
          ...(status && { status }),
          ...(search && { search }),
        },
      }
    );
    return response.data;
  },

  getEmail: async (emailId: string) => {
    const response = await axiosInstance.get<InboxDetailResponse>(
      `/inbox-emails/${emailId}`
    );
    return response.data;
  },

  linkToDeal: async (
    emailId: string,
    dealId: string,
    companyId?: string,
    fileTypes?: Record<string, string>,
    workspaceId?: string
  ) => {
    const response = await axiosInstance.put<InboxUpdateResponse>(
      `/inbox-emails/${emailId}/link`,
      {
        deal_id: dealId,
        company_id: companyId,
        ...(workspaceId && { workspace_id: workspaceId }),
        ...(fileTypes && { file_types: fileTypes }),
      }
    );
    return response.data;
  },

  attachFilesToCompany: async (
    emailId: string,
    companyId: string,
    fileTypes: Record<string, string>
  ) => {
    const response = await axiosInstance.put<{ status: string }>(
      `/inbox-emails/${emailId}/attach-files`,
      {
        company_id: companyId,
        file_types: fileTypes,
      }
    );
    return response.data;
  },

  updateStatus: async (emailId: string, status: InboundEmailStatus) => {
    const response = await axiosInstance.put<InboxUpdateResponse>(
      `/inbox-emails/${emailId}/status`,
      { status }
    );
    return response.data;
  },

  convertToDeal: async (
    emailId: string,
    companyName: string,
    companyWebsite?: string
  ) => {
    const response = await axiosInstance.post<ConvertEmailToDealResponse>(
      `/inbox-emails/${emailId}/convert-to-deal`,
      {
        company_name: companyName,
        company_website: companyWebsite,
      }
    );
    return response.data;
  },

  deleteEmail: async (emailId: string) => {
    const response = await axiosInstance.delete<{ status: string }>(
      `/inbox-emails/${emailId}`
    );
    return response.data;
  },
};
